import { Component, inject, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { OAuthService } from "angular-oauth2-oidc";
import { TokenService } from "@auth/services/token/token.service";
import { AuthService } from "@auth/services/auth/auth.service";
import { SessionStorageService } from "@shared/services/session-storage.service";
import { SessionStorageKeys } from "@shared/services/static/session-storage-keys";
import { AppInsightsService } from "@api/services/app-insights/app-insights.service";
import { ToastModule } from "primeng/toast";

@Component({
    selector: "app-signin-callback-component",
    imports: [ToastModule],
    template: `
        <p>Loading...</p>
        <p-toast key="global-toast" position="bottom-right"></p-toast>
    `,
})
export class SigninCallbackComponent implements OnInit {
    private readonly router = inject(Router);
    private readonly oauthService = inject(OAuthService);
    private readonly tokenService = inject(TokenService);
    private readonly authService = inject(AuthService);
    private readonly route = inject(ActivatedRoute);
    private readonly sessionStorageService = inject(SessionStorageService);
    private readonly appInsightsService = inject(AppInsightsService);

    ngOnInit(): void {
        const authCode = this.route.snapshot.queryParamMap.get("code");
        if (authCode) {
            this.sessionStorageService.setItem(SessionStorageKeys.AuthCode, authCode);
        }

        this.oauthService.loadDiscoveryDocumentAndTryLogin().then(
            (success) => {
                if (success && this.tokenService.isTokenClaimsValid()) {
                    this.sessionStorageService.clearAcwState();

                    // NOTE - BS - no separate routing actions needed here; the app component will handle all
                    //             app initialization and routing once the authStateService.authenticationCompleted$
                    //             emits.
                    this.authService.notifyAuthenticationComplete();
                } else {
                    this.appInsightsService.logTrace("Signin callback: token validation failed");
                    this.router.navigate(["/unauthorized"]);
                }
            },
            (error) => {
                this.appInsightsService.logTrace("Signin callback error: " + error);
                this.sessionStorageService.clearAllState();
                this.oauthService.initCodeFlow();
            },
        );
    }
}
